export const REQUIRED_FIELD_ERROR = "Поле обов'язкове";

export const getRequiredFieldError = (
  showErrors: boolean,
  isValid: boolean
): string | null => {
  return showErrors && !isValid ? REQUIRED_FIELD_ERROR : null;
};
